import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { isNight } from "@/lib/night";

const KEY = "fhp-night";
// Stored: "auto" (default) or a manual choice {"on": bool, "until": ms}, which lasts until the next sunrise/sunset flip.
const readPref = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; } };

export function nightOn() {
  const pref = readPref();
  const auto = isNight();
  if (pref && typeof pref === "object" && pref.until > Date.now() && pref.auto === auto) return pref.on;
  return auto;
}

const apply = (on) => document.documentElement.classList.toggle("night", on);
apply(nightOn());

export function NightToggle({ t }) {
  const [on, setOn] = useState(nightOn);
  useEffect(() => {
    const tick = () => { const v = nightOn(); setOn(v); apply(v); };
    const id = setInterval(tick, 60000);
    return () => clearInterval(id);
  }, []);
  const flip = () => {
    const next = !on;
    setOn(next); apply(next);
    try { localStorage.setItem(KEY, JSON.stringify({ on: next, auto: isNight(), until: Date.now() + 16 * 3600e3 })); } catch { /* private mode */ }
  };
  return (
    <button type="button" className={`header-btn ${on ? "header-btn-on" : ""}`} data-testid="night-toggle"
      aria-pressed={on} aria-label={on ? t("Turn off night mode") : t("Night mode")} onClick={flip}>
      {on ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
